import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { PLATFORM_DASHBOARD_TABS } from '../lib/platform-dashboard-layout'

type TabKey = 'people' | 'revenue' | 'tokens'

interface Props {
  activeTab: TabKey
}

const TABS: Array<{ key: TabKey; label: string; disabled?: boolean }> = [
  { key: 'people', label: 'People & Accounts' },
  { key: 'revenue', label: 'Revenue & Billing', disabled: true },
  { key: 'tokens', label: 'Token Usage', disabled: true },
]

const { tabWidths } = PLATFORM_DASHBOARD_TABS

export function PlatformDashboardTabs({ activeTab }: Props) {
  return (
    <Box
      data-testid="platform-dashboard-tabs"
      sx={{
        display: 'inline-flex',
        alignItems: 'flex-start',
        gap: PLATFORM_DASHBOARD_TABS.gap,
        p: PLATFORM_DASHBOARD_TABS.p,
        mb: 3,
        bgcolor: '#fff',
        borderRadius: PLATFORM_DASHBOARD_TABS.borderRadius,
        boxShadow: PLATFORM_DASHBOARD_TABS.boxShadow,
      }}
    >
      {TABS.map((tab) => {
        const active = tab.key === activeTab
        const disabled = Boolean(tab.disabled)
        return (
          <Box
            key={tab.key}
            component={disabled ? 'div' : 'button'}
            type={disabled ? undefined : 'button'}
            aria-disabled={disabled || undefined}
            aria-current={active ? 'page' : undefined}
            data-testid={`platform-dashboard-tab-${tab.key}`}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: PLATFORM_DASHBOARD_TABS.tabInnerGap,
              minWidth: tabWidths[tab.key],
              width: tabWidths[tab.key],
              px: PLATFORM_DASHBOARD_TABS.tabPx,
              py: PLATFORM_DASHBOARD_TABS.tabPy,
              borderRadius: PLATFORM_DASHBOARD_TABS.tabBorderRadius,
              border: 'none',
              bgcolor: active ? '#008cd0' : 'transparent',
              color: active ? '#fff' : '#6b7280',
              cursor: disabled ? 'default' : 'pointer',
              pointerEvents: disabled ? 'none' : 'auto',
              fontFamily: 'inherit',
              fontSize: '14px',
              fontWeight: 700,
              lineHeight: '20px',
              letterSpacing: '-0.1504px',
              whiteSpace: 'nowrap',
            }}
          >
            {tab.label}
            {disabled && (
              <Box
                component="span"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '16px',
                  px: '10px',
                  borderRadius: '100px',
                  bgcolor: '#e3f2fd',
                }}
              >
                <Typography
                  component="span"
                  sx={{
                    fontSize: '8px',
                    fontWeight: 500,
                    lineHeight: '16px',
                    color: '#1976d2',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Coming Soon
                </Typography>
              </Box>
            )}
          </Box>
        )
      })}
    </Box>
  )
}
